import React, { useState } from 'react';
import { Input, Select, DatePicker, Button, Space } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';
import type { AuditLogFilter } from '../../../services/auditLogApi';

const ACTION_OPTIONS = [
  { value: 'create', label: '新增' },
  { value: 'update', label: '修改' },
  { value: 'delete', label: '刪除' },
  { value: 'approve', label: '核准' },
  { value: 'reject', label: '退回' },
  { value: 'void', label: '作廢' },
  { value: 'export', label: '匯出' },
  { value: 'print', label: '列印' },
  { value: 'grant', label: '授權異動' },
];

interface FilterBarProps {
  loading: boolean;
  onSearch: (filter: Partial<AuditLogFilter>) => void;
  onReset: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ loading, onSearch, onReset }) => {
  const [userId, setUserId] = useState('');
  const [formId, setFormId] = useState('');
  const [docKey, setDocKey] = useState('');
  const [action, setAction] = useState<string | undefined>(undefined);
  const [range, setRange] = useState<[Dayjs | null, Dayjs | null] | null>(null);

  const handleSearch = () => {
    onSearch({
      user_id: userId.trim() || undefined,
      form_id: formId.trim() || undefined,
      doc_key: docKey.trim() || undefined,
      action,
      from: range?.[0] ? range[0].format('YYYY-MM-DD') : undefined,
      to: range?.[1] ? range[1].format('YYYY-MM-DD') : undefined,
      page: 1,
    });
  };

  const handleReset = () => {
    setUserId(''); setFormId(''); setDocKey(''); setAction(undefined); setRange(null);
    onReset();
  };

  return (
    <Space wrap style={{ marginBottom: 16 }}>
      <Input
        placeholder="使用者"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
        onPressEnter={handleSearch}
        style={{ width: 140 }}
        allowClear
      />
      <Input
        placeholder="表單代碼 (form_id)"
        value={formId}
        onChange={(e) => setFormId(e.target.value)}
        onPressEnter={handleSearch}
        style={{ width: 160 }}
        allowClear
      />
      <Input
        placeholder="單號 (doc_key)"
        value={docKey}
        onChange={(e) => setDocKey(e.target.value)}
        onPressEnter={handleSearch}
        style={{ width: 160 }}
        allowClear
      />
      <Select
        placeholder="動作"
        value={action}
        onChange={setAction}
        options={ACTION_OPTIONS}
        style={{ width: 130 }}
        allowClear
      />
      <DatePicker.RangePicker
        value={range}
        onChange={(v) => setRange(v as [Dayjs | null, Dayjs | null] | null)}
        allowClear
      />
      <Button type="primary" icon={<SearchOutlined />} loading={loading} onClick={handleSearch}>
        查詢
      </Button>
      <Button icon={<ReloadOutlined />} onClick={handleReset}>
        重置
      </Button>
    </Space>
  );
};

export default FilterBar;
